export type UploadedSharedFile = {
    signedId: string
    name: string
    mimeType: string
    size: number
}

export type UploadedShareAttachmentField = 'images' | 'recording' | 'files'

export function attachmentFieldForUploadedShare(
    uploadedFile: UploadedSharedFile,
): UploadedShareAttachmentField {
    if (uploadedFile.mimeType.startsWith('image/')) return 'images'
    if (uploadedFile.mimeType.startsWith('video/')) return 'recording'
    return 'files'
}

export function activeStorageUrlForUploadedShare(
    uploadedFile: UploadedSharedFile,
    apiBaseUrl: string,
) {
    const safeFilename = encodeURIComponent(uploadedFile.name.split('/').pop() || 'shared-upload')
    return `${apiBaseUrl.replace(
        /\/+$/,
        '',
    )}/rails/active_storage/blobs/redirect/${encodeURIComponent(
        uploadedFile.signedId,
    )}/${safeFilename}`
}

export function uploadedShareDraftPatch(
    uploadedFile: UploadedSharedFile,
    apiBaseUrl: string,
): Record<string, unknown> {
    const previewUrl = activeStorageUrlForUploadedShare(uploadedFile, apiBaseUrl)
    const attachmentField = attachmentFieldForUploadedShare(uploadedFile)

    if (attachmentField === 'images') {
        return {
            answer_image: uploadedFile.signedId,
            answer_image_url: previewUrl,
        }
    }

    if (attachmentField === 'recording') {
        return {
            recording: uploadedFile.signedId,
            recording_url: previewUrl,
            recording_content_type: uploadedFile.mimeType || 'video/mp4',
            original_recording_type: uploadedFile.mimeType || 'video/mp4',
        }
    }

    return {
        files: [uploadedFile.signedId],
        file_urls: [
            {
                url: previewUrl,
                file_url: previewUrl,
                name: uploadedFile.name,
                content_type: uploadedFile.mimeType || 'application/octet-stream',
            },
        ],
    }
}
